import React, { useEffect, useMemo, useState } from "react";
import PageHero from "@/components/PageHero";
import PageMeta from "@/components/PageMeta";
import TeamCard from "@/components/TeamCard";
import { api } from "@/lib/api";

export default function Teams() {
  const [teams, setTeams] = useState([]);
  const [filter, setFilter] = useState("ALL");

  useEffect(() => { api.get("/teams").then((r) => setTeams(r.data)).catch(() => {}); }, []);

  const states = useMemo(() => Array.from(new Set(teams.map((t) => t.state))), [teams]);
  const filtered = filter === "ALL" ? teams : teams.filter((t) => t.state === filter);

  return (
    <div>
      <PageMeta
        title="The Franchise Eight — PSHL8 Teams"
        description="8 city-state franchises form the inaugural PSHL8 season. Each team carries its city's pride into the rink."
        image="/api/og/teams/og-image.png"
      />
      <PageHero
        overline="Inaugural Franchises"
        title={<>The Franchise <span className="text-pshl-electric">Eight.</span></>}
        subtitle="Eight city-state franchises form the inaugural PSHL8 season. Each team carries its city's pride into the rink."
        bgImage="https://images.pexels.com/photos/6468923/pexels-photo-6468923.jpeg"
      />

      <section className="section pt-0">
        <div className="pshl-container">
          <div className="flex flex-wrap gap-2 mb-8" data-testid="team-filters">
            <button
              data-testid="filter-all"
              onClick={() => setFilter("ALL")}
              className={`text-[11px] font-display uppercase tracking-[0.22em] px-4 py-2 border transition-colors ${
                filter === "ALL" ? "bg-pshl-electric border-pshl-electric text-white" : "border-white/15 text-white/80 hover:border-white"
              }`}
            >All</button>
            {states.map((s) => (
              <button
                key={s}
                data-testid={`filter-${s.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setFilter(s)}
                className={`text-[11px] font-display uppercase tracking-[0.22em] px-4 py-2 border transition-colors ${
                  filter === s ? "bg-pshl-electric border-pshl-electric text-white" : "border-white/15 text-white/80 hover:border-white"
                }`}
              >{s}</button>
            ))}
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {filtered.map((t, i) => <TeamCard key={t.slug} team={t} index={i} />)}
          </div>
        </div>
      </section>
    </div>
  );
}
